import { render } from "./VendorCashExpense.vue?vue&type=template&id=db501eec"
import script from "./VendorCashExpense.vue?vue&type=script&lang=js"
export * from "./VendorCashExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__